export const FILTER_SEARCH_GROUP_ID = 'actionsSearchInput';

export const FILTER_SEARCH_FIELD_ID = 'searchInput';
